export const ADDITIONS = [
  {
    Name: 'NOTIFIABLE_WORKS',
    ExecuteField: 'NotifiableWorksResponsible',
    PayField: 'NotifiableWorksCosts',
    CommentField: 'NotifiableWorksPrice'
  },
  {
    Name: 'CLARIFY_INFRASTRUCTURE',
    ExecuteField: 'ClarifyInfrastructureResponsible',
    PayField: 'ClarifyInfrastructureCosts',
    CommentField: 'ClarifyInfrastructurePrice'
  },
  {
    Name: 'SIGN_PLAN_PUBLIC_ROAD',
    ExecuteField: 'SignPlanPublicRoadResponsible',
    PayField: 'SignPlanPublicRoadCosts',
    CommentField: 'SignPlanPublicRoadPrice'
  },
  {
    Name: 'REMEDTATION_OF_ROAD',
    ExecuteField: 'RemediationOfRoadResponsible',
    PayField: 'RemediationOfRoadCosts',
    CommentField: 'RemediationOfRoadPrice'
  },
  {
    Name: 'DIGGING_ROAD_BUILDING',
    ExecuteField: 'DiggingRoadBuildingResponsible',
    PayField: 'DiggingRoadBuildingCosts',
    CommentField: 'DiggingRoadBuildingPrice'
  },
  {
    Name: 'PLOWING_GRITTING',
    ExecuteField: 'PlowingGrittingResponsible',
    PayField: 'PlowingGrittingCosts',
    CommentField: 'PlowingGrittingPrice'
  },
  {
    Name: 'MANUAL_WORK',
    ExecuteField: 'ManualWorkResponsible',
    PayField: 'ManualWorkCosts',
    CommentField: 'ManualWorkPrice'
  },
  {
    Name: 'DRIVING_TRACKS',
    ExecuteField: 'DrivingTracksResponsible',
    PayField: 'DrivingTracksCosts',
    CommentField: 'DrivingTracksPrice'
  },
  {
    Name: 'NEIGHBOR_ESTATE_ASSESSMENT',
    ExecuteField: 'NeighborEstateAssessmentResponsible',
    PayField: 'NeighborEstateAssessmentCosts',
    CommentField: 'NeighborEstateAssessmentPrice'
  },
  {
    Name: 'MARKING_OF_PROPERTY_BOUNDARY',
    ExecuteField: 'MarkingOfPropertyBoundaryResponsible',
    PayField: 'MarkingOfPropertyBoundaryCosts',
    CommentField: 'MarkingOfPropertyBoundaryPrice'
  }
]
